import { render, staticRenderFns } from "./ChatBotIcon.vue?vue&type=template&id=56cf0ff2&scoped=true&"
import script from "./ChatBotIcon.vue?vue&type=script&lang=js&"
export * from "./ChatBotIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotIcon.vue?vue&type=style&index=0&id=56cf0ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf0ff2",
  null
  
)

export default component.exports